"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Button.scss");
var _ButtonMethods = require("./ButtonMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Button = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _ButtonMethods.renderButton)(props));
};
var _default = Button;
exports.default = _default;
Button.propTypes = {
  onClick: _propTypes.default.func,
  url: _propTypes.default.string,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  mouse: _propTypes.default.bool
};